import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Puzzle } from 'lucide-react';
import DotyposIntegration from '@/components/business/DotyposIntegration';

interface IntegrationsSectionProps {
  businessId: string;
}

const IntegrationsSection: React.FC<IntegrationsSectionProps> = ({ businessId }) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Puzzle className="h-5 w-5 text-muted-foreground" />
          <div>
            <CardTitle>Integrations</CardTitle>
            <CardDescription>
              Connect external services to enhance your business capabilities
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Integration Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Dotypos POS Integration */}
          <DotyposIntegration businessId={businessId} />
        </div>

        {/* More Coming Soon */}
        <div className="rounded-lg border border-dashed p-4 text-center">
          <p className="text-sm text-muted-foreground">
            More integrations coming soon...
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default IntegrationsSection;
